export default __webpack_public_path__ + "static/media/branding-logo-crop.97e47db0.png";